import Icon from '../../components/Icon.vue'

Icon.register({"brands/wpforms":{"width":448,"height":512,"paths":[{"d":"M448 75.2V436.9C448 461.2 429 480.1 404.8 480.1H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32H404.9C428.9 32 448 50.8 448 75.2zM410.7 436.8V75.2C410.7 72.2 408.1 69.4 404.9 69.4H395.6L285.3 144 224 94.1 162.8 144 52.5 69.3H43.2C40 69.3 37.4 72.1 37.4 75.1V436.8C37.4 439.8 40 442.6 43.2 442.6H404.9C408.1 442.7 410.7 439.9 410.7 436.8zM150.2 186V223H76.7V186H150.2zM150.2 260.4V297.7H76.7V260.4H150.2zM161.3 113.1L215.3 69.4H96.8L161.3 113.1zM371.3 186V223H175.3V186H371.3zM371.3 260.4V297.7H175.3V260.4H371.3zM286.7 113.1L351.2 69.4H232.8L286.7 113.1zM371.3 335V372.3H271.9V335H371.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpforms.js
// module id = iuix
// module chunks = 0